export default "__VITE_ASSET__CfwOVmfp__"